import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconQrCode: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconQrCode"><Path d="M13.5 13.5V16.5H16.5M17.5 13.5H20.5M20.5 17.5H17.5V20.5M13.5 20.5V19.5M10.5 3.5H3.5V10.5H10.5V3.5ZM3.5 13.5H10.5V20.5H3.5V13.5ZM13.5 3.5H20.5V10.5H13.5V3.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconQrCode;
